import script from "./SendCommands.vue?vue&type=script&setup=true&lang=js"
export * from "./SendCommands.vue?vue&type=script&setup=true&lang=js"

import "./SendCommands.vue?vue&type=style&index=0&id=8b6c4ec2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b6c4ec2"]])

export default __exports__